import React, { lazy, Suspense, useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { decodeToken } from "./utility/constant";
import { useSelector } from "react-redux";
import { selectToken } from "./utility/Redux/security";
import { ActivationAccount, Auth, NotFound } from "./auth";
import LoginV3 from "./auth/login/loginV3";
import ContactUs from "./auth/contactUs";

import {
  CustomerMaster,
  DepartMentMaster,
  ItemMaster,
  SectionMaster,
  SubSecMaster,
} from "./masters/index";

// 📊 Reports
import { Reports, ItemWiseSaleReport } from "./reports";
import SaleSummary from "./reports/saleSummary";
import EInvoiceHub from "./reports/eInvoiceHub";
import PendingDeliverdPayments from "./reports/pendingDeliverdPayments";
import ItemExpiryReport from "./reports/itemExpiryReport";
import DebitNoteReport from "./reports/debitNoteReport";
import CreditNoteReport from "./reports/creditNoteReport";
import ReciveSummary from "./reports/recieveSummary";
import DepWiseRecieve from "./reports/depWiseRecieve";

// ⚙️ Settings
import AppSettings from "./settings/appSettings";
import CrossAppCompanySetting from "./settings/bannerSettings/crossAppCompanySettings";
import CrossBanners from "./settings/bannerSettings/crossBanners";
import AliosImgLibrary from "./settings/alias_img_library";
import ImageMaster from "./settings/imageLibrary";

// 💰 Accounts
import AccountsPage from "./accounts/dashboard";
import Trailbalance from "./accounts/reports/trailBalance/trialBalance";
import TrialBalanceAccountPage from "./accounts/reports/trailBalance_account_head_wise";
import Account_ledger from "./accounts/reports/accountLedger";
import Account_Reconcillation from "./accounts/reports/account_reconcillation";

// 💼 Others
import SpinnerLoading from "./utility/component/modals/spinnerLoading";
import VoucherEntery from "./VouhcerEntery";
import StockOrdering from "./CreateOrder";
import Purchase from "./purchase";
import DebitNote from "./debitNote";
import CreditNote from "./creditNote";
import LandingPage from "./landingPage";
import WhatsAppSettings from "./settings/whatsappSettng";
import ItemWiseOrder from "./reports/itemWiseOrder";
import NewOfferMaster from "./masters/newOfferMaster";
import MarginReport from "./reports/marginReport";
import PurchasePaymentVoucher2 from "./updation/newPurchasePaymentVoucher";
import PurchaseVoucherSummary from "./reports/PurchaseVoucherSummary";
import SectionWiseOffer from "./reports/sectionWiseOffer";
import VersionControl from "./settings/versionControls";
import DateWiseChequeSummary from "./reports/dateWiseCheqkSummary";
import SaleryPaymentVoucher from "./updation/saleryPaymentVoucher";

const ItemWisePurchaseReport = lazy(() =>
  import("./reports/itemWisePurchaseSummary")
);
const MobileSignUp = lazy(() => import("./auth/mobilesignup/index3"));
const ResetEmail = lazy(() => import("./auth/resetUserEmail"));
const PartyMaster = lazy(() => import("./masters/account-master"));
const OfferMaster = lazy(() => import("./masters/offer-master"));
const HsnMaster = lazy(() => import("./masters/hsn-master"));
const PurchaseSummary = lazy(() => import("./reports/purchaseSummary"));
const UserMaster = lazy(() => import("./settings/userMaster"));
const ExpenseMaster = lazy(() => import("./masters/expense"));
const PaymentVoucher = lazy(() => import("./updation/paymentVoucher"));
const VoucherSummary = lazy(() => import("./reports/voucherSummary"));
const MessageSetupMaster = lazy(() => import("./settings/messageSetupMaster"));
const CompanyMaster = lazy(() => import("./settings/companyMaster"));
const OfferList = lazy(() => import("./reports/offerSummery"));
const RecieptVoucher = lazy(() => import("./updation/recieptVoucher"));
const Dashboard = lazy(() => import("./dashboard"));
const ForgotPassword = lazy(() => import("../src/auth/changePassword"));
const InvoiceBill = lazy(() => import("./invoice"));
const TrailBalnce_Opening_bal_wis = lazy(() =>
  import("./accounts/reports/trailBalance_opening_bal_wise")
);

const Masters = lazy(() => import("./masters/dashboard"));
const PurchaseDashboard = lazy(() => import("./purchase/dahsboard"));
const UserDefaultSetting = lazy(() => import("./settings/userDefaultSetting"));
const ProtectedRoute = lazy(() => import("./auth/util/protectedRoute"));
const Home = lazy(() => import("./home"));
const VerifyEmail = lazy(() => import("./auth/verifyEmail"));
const Updation = lazy(() => import("./updation/dashboard"));
const Settings = lazy(() => import("./settings/dashboard"));
const NewLoginDesign = lazy(() => import("./auth/loginNewDesign"));
const SaleTaxReport = lazy(() => import("./reports/saleTaxReport"));
const PaymodeSummary = lazy(() => import("./reports/payModeSummary"));
const ItemWisePurchase = lazy(() => import("./reports/itemWiseHistory"));
const ItemStatus = lazy(() => import("./reports/itemStatus"));
const StockReport = lazy(() => import("./reports/stockReport"));
const QRCodeScanner = lazy(() => import("./utility/component/AllScanner"));
const CreateCompanyDb = lazy(() => import("./settings/createDatabase"));
const Billing = lazy(() => import("./billing"));
const BillDashboard = lazy(() => import("./dashboard/billDashboard"));
const ExpiryReport = lazy(() => import("./reports/expiryReport"));
const CustomerLedger = lazy(() => import("./reports/customerLedger"));
const CustomerBalReport = lazy(() => import("./reports/CustomerBalReport"));
const PartyLedger = lazy(() => import("./reports/partyLedger"));
const PartyBalReport = lazy(() => import("./reports/partyWiseBalance"));
const order_report = lazy(() => import("./reports/order_report"));
const accountsPages = lazy(() => import("./accounts/dashboard"));
const balSheetHeadMaster = lazy(() =>
  import("./masters/bal_sheet_head_master")
);
const PurchasePaymentVoucher = lazy(() =>
  import("./updation/purchasePaymentVoucher")
);
const UpdatepurchaseToAcc = lazy(() =>
  import("./accounts/updatePurchaseToAcc")
);
const DFRReport = lazy(() => import("./reports/dfrReport"));
const LiveMap = lazy(() => import("./reports/fieldWayLocation"));
const ReceivedOrders = lazy(() => import("./reports/recievedOrders"));
const RecivedOrderDashboard = lazy(() =>
  import("./dashboard/recivedOrderDashboard")
);

const DailyStockMoveReport = lazy(() => import("./reports/dailyStockMovement"));
const PartyItemsSale = lazy(() => import("./reports/partyItemsSale"));
const CrossCompanyList = lazy(() => import("./settings/retailxCrossAllow"));
const CustomerEmailVerified = lazy(() => import("./verify/verifyCustomer"));
const PaymentForm = lazy(() => import("./billing/billingModalNew"));
const UserScopesMaster = lazy(() => import("./settings/user_scopes_master"));
const EmployeeMaster = lazy(() => import("./masters/employee-master"));
const TemplateMaster = lazy(() => import("./masters/templateMaster"));
const NewLoginModal = lazy(() => import("./auth/newLogin"));
const BulkChangeMaster = lazy(() => import("./masters/bulkChangeMaster"));
const BranchItemMaster = lazy(() => import("./masters/branch-item-master"));
const ImageLibrary = lazy(() => import("./settings/imageLibrary"));
const Issue = lazy(() => import("./Issue"));
const IssueSummary = lazy(() => import("./reports/issueSummary"));
const DepWiseIssue = lazy(() => import("./reports/depWiseIssue"));
const ItemWiseIssue = lazy(() => import("./reports/itemWiseIssue"));
const TermAndCondition = lazy(() => import("./auth/terms"));
export const privateRoutes = [
  // Master Routes
  {
    path: "/account_master",
    element: PartyMaster,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Godown",
    required_scopes: "read:accounts,write:accounts",
  },
  {
    path: "/company_master",
    element: CompanyMaster,
    userType: "ADMIN",
    type: "master",
    plan_type: "Premium",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/customer_master",
    element: CustomerMaster,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Standard",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/version_controle",
    element: VersionControl,
    userType: "ADMIN",
    type: "master",
    plan_type: "Premium,Godown",
    required_scopes: "read:accounts,write:accounts",
  },
  {
    path: "/item_master",
    element: ItemMaster,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/branch_item_master",
    element: BranchItemMaster,
    userType: "MANAGER ADMIN",
    type: "master",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/margin_report",
    element: MarginReport,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:report,write:report",
  },
  {
    path: "/cheque_summary",
    element: PurchaseVoucherSummary
    ,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:report,write:report",
  },
  {
    path: "/template_master",
    element: TemplateMaster,
    userType: "ADMIN",
    type: "master",
    plan_type: "Premium",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/department_master",
    element: DepartMentMaster,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Godown",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/whatsapp_sender_setting",
    element: WhatsAppSettings,
    userType: "ADMIN",
    type: "master",
    plan_type: "Premium",
  },
  {
    path: "/expense_master",
    element: ExpenseMaster,
    userType: "MANAGER ADMIN",
    type: "master",
    plan_type: "Premium,Standard",
    required_scopes: "read:master,write:master",
  },  {
    path: "/pending_payments_of_deliverd",
    element: PendingDeliverdPayments,
    userType: "MANAGER ADMIN",
    type: "reports",
    plan_type: "Premium,Standard",
    required_scopes: "read:reports,write:reports",
  },
  {
    path: "/hsn_master",
    element: HsnMaster,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/section_master",
    element: SectionMaster,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/sub_section_master",
    element: SubSecMaster,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/employee_master",
    element: EmployeeMaster,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/offer_master",
    element: NewOfferMaster,
    userType: "allowed",
    type: "master",
    plan_type: "Premium,Standard",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/user_master",
    element: UserMaster,
    userType: "MANAGER ADMIN",
    type: "settings",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:master,write:master",
  },
  // {
  //   path: "/bal_sheet_head_master",
  //   element: balSheetHeadMaster,
  //   userType: "allowed",
  //   type: "master",
  //   plan_type: "Premium,Standard,Godown",
  // },
  {
    path: "/bulk_change_master",
    element: BulkChangeMaster,
    userType: "MANAGER ADMIN",
    type: "master",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:master,write:master",
  },
  {
    path: "/message_setup_master",
    element: MessageSetupMaster,
    userType: "ADMIN",
    type: "master",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:master,write:master",
  },

  // Report Routes
  {
    path: "/sale_tax_report",
    element: SaleTaxReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Standard",
    required_scopes: "read:report",
  },
  {
    path: "/paymode_summary",
    element: PaymodeSummary,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Standard",
    required_scopes: "read:report",
  },
  {
    path: "/item_wise_purchase_report",
    element: ItemWisePurchaseReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/section_wise_offer_report",
    element: SectionWiseOffer,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/item_wise_sale_report",
    element: ItemWiseSaleReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Standard",
    required_scopes: "read:report",
  },
  {
    path: "/stock_report",
    element: StockReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/sale_summary",
    element: SaleSummary,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Standard",
    required_scopes: "read:report",
  },
  {
    path: "/e_invoice_hub",
    element: EInvoiceHub,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Standard",
    required_scopes: "read:report",
  },
  {
    path: "/purchase_summary",
    element: PurchaseSummary,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/Closing_Value_Report",
    element: DailyStockMoveReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/party_bal_report",
    element: PartyBalReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/customer_balance_report",
    element: CustomerBalReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Standard",
    required_scopes: "read:report",
  },
  {
    path: "/expiry_report",
    element: ExpiryReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/item_expiry_report",
    element: ItemExpiryReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/order_report",
    element: order_report,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:stock_orders",
  },
  {
    path: "/debit_note_report",
    element: DebitNoteReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/credit_note_report",
    element: CreditNoteReport,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/voucher_summary",
    element: VoucherSummary,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/date_wise_cheque_count_summary",
    element: DateWiseChequeSummary,
    userType: "allowed",
    type: "reports",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  // {
  //   path: "/account_reconcillation_report",
  //   element: Account_Reconcillation,
  //   userType: "allowed",
  //   type: "reports",
  //   plan_type: "Premium,Standard,Godown",
  // },

  {
    path: "/reports",
    element: Reports,
    userType: "allowed",
    type: "menu",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/fieldway_dfr",
    element: DFRReport,
    userType: "ADMIN",
    type: "reports",
    plan_type: "Premium,Standard,Godown",
    required_scopes: "read:report",
  },

  // Dashboard Routes
  {
    path: "/dashboard",
    element: Dashboard,
    userType: "ADMIN",
    type: "dashboard",
    plan_type: "Premium,Standard,Godown",
  },
  {
    path: "/purchase_dashboard",
    element: PurchaseDashboard,
    userType: "allowed",
    type: "menu",
    plan_type: "Premium,Godown",
  },
  {
    path: "/order_dashboard",
    element: RecivedOrderDashboard,
    required_scopes: "read:billing,write:billing",
    userType: "allowed",
    type: "menu",
    plan_type: "Premium,Godown",
  },
  // {
  //   path: "/select_bill_type",
  //   element: BillDashboard,
  //   userType: "allowed",
  //   type: "dashboard",
  //   plan_type: "Premium,Standard,Godown",
  // },

  // Accounting Routes
  // {
  //   path: "/voucher_entery",
  //   element: VoucherEntery,
  //   userType: "MANAGER ADMIN",
  //   type: "accounting",
  //   plan_type: "Premium,Standard,Godown",
  // },
  {
    path: "/payment_voucher",
    element: PaymentVoucher,
    userType: "allowed",
    type: "accounting",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/salary_payment_voucher",
    element: SaleryPaymentVoucher,
    userType: "allowed",
    type: "accounting",
    plan_type: "Premium,Godown",
    required_scopes: "read:report",
  },
  {
    path: "/reciept_voucher",
    element: RecieptVoucher,
    userType: "allowed",
    type: "accounting",
    plan_type: "Premium,Godown",
    required_scopes: "read:voucher",
  },
  {
    path: "/pur_payment_voucher",
    element: PurchasePaymentVoucher,
    userType: "allowed",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:voucher,write:voucher",
  },
  {
    path: "/account_ledger",
    element: Account_ledger,
    userType: "allowed",
    type: "accounting",
    plan_type: "Premium,Standard,Godown",
  },
  {
    path: "/party_ledger",
    element: PartyLedger,
    userType: "allowed",
    type: "accounting",
    plan_type: "Premium,Godown",
    required_scopes: "read:master,write:report",
  },
  {
    path: "/customer_ledger",
    element: CustomerLedger,
    userType: "allowed",
    type: "accounting",
    plan_type: "Premium,Standard",
    required_scopes: "read:master,write:report",
  },
  // {
  //   path: "/accounts",
  //   element: AccountsPage,
  //   userType: "allowed",
  //   type: "menu",
  //   plan_type: "Premium,Standard,Godown",
  // },
  {
    path: "/credit_note",
    element: CreditNote,
    userType: "allowed",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:master",
  },
  {
    path: "/debit_note",
    element: DebitNote,
    userType: "allowed",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:master",
  },
  // {
  //   path: "/trial_balance_under_group_wise",
  //   element: Trailbalance,
  //   userType: "allowed",
  //   type: "accounting",
  //   plan_type: "Premium,Standard,Godown",
  // },
  // {
  //   path: "/trial_balance_opening_balance_wise",
  //   element: TrailBalnce_Opening_bal_wis,
  //   userType: "allowed",
  //   type: "accounting",
  //   plan_type: "Premium,Standard,Godown",
  // },
  // {
  //   path: "/trial_balance_account_head_wise",
  //   element: TrialBalanceAccountPage,
  //   userType: "allowed",
  //   type: "accounting",
  //   plan_type: "Premium,Standard,Godown",
  // },

  // Billing/Transactions
  {
    path: "/billing",
    element: Billing,
    userType: "USER MANAGER",
    type: "menu",
    plan_type: "Premium,Standard",
    required_scopes: "read:master,read:billing,write:billing",
    read_write: "read:billing,write:billing",
  },
  {
    path: "/item_wise_order",
    element: ItemWiseOrder,
    userType: "USER MANAGER",
    type: "reports",
    plan_type: "Premium,Standard",
    required_scopes: "read:master",
  },
  {
    path: "/purchase",
    element: Purchase,
    userType: "allowed",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:master,read:purchase,write:purchase",
    read_write: "read:purchase,write:purchase",
  },
  {
    path: "/item_wise_purchase",
    element: ItemWisePurchase,
    userType: "allowed",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:purchase,read:master",
  },
  {
    path: "/offer_list",
    element: OfferList,
    userType: "allowed",
    type: "transaction",
    plan_type: "Premium,Standard",
  },
  {
    path: "/party_Items_Sale",
    element: PartyItemsSale,
    userType: "allowed",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:report,read:master",
  },
  {
    path: "/stock_ordering",
    element: StockOrdering,
    userType: "allowed",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:report,read:master",
  },
  {
    path: "/issue",
    element: Issue,
    userType: "allowed",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:accounts",
  },
  // {
  //   path: "/update_purchase_to_accounts",
  //   element: UpdatepurchaseToAcc,
  //   userType: "allowed",
  //   type: "transaction",
  //   plan_type: "Premium,Godown",
  // },

  // Store-Specific Routes
  {
    path: "/issue_summary",
    element: IssueSummary,
    userType: "MANAGER STORE",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:accounts,read:report",
  },
  {
    path: "/recieve_summary",
    element: ReciveSummary,
    userType: "MANAGER STORE",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:accounts,read:report",
  },
  {
    path: "/dep_wise_recieve",
    element: DepWiseRecieve,
    userType: "MANAGER STORE",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:accounts,read:report",
  },
  {
    path: "/dep_wise_issue",
    element: DepWiseIssue,
    userType: "MANAGER STORE",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:accounts,read:report",
  },
  {
    path: "/item_wise_issue",
    element: ItemWiseIssue,
    userType: "MANAGER STORE",
    type: "transaction",
    plan_type: "Premium,Godown",
    required_scopes: "read:accounts,read:report",
  },

  // Admin Settings & Control
  {
    path: "/cross_company_list",
    element: CrossCompanyList,
    userType: "ADMIN",
    type: "settings",
    plan_type: "Premium",
  },
  {
    path: "/cross_app_company_settings",
    element: CrossAppCompanySetting,
    userType: "ADMIN",
    type: "settings",
    plan_type: "Premium",
  },
  {
    path: "/cross_banners",
    element: CrossBanners,
    userType: "ADMIN",
    type: "settings",
    plan_type: "Premium",
  },
  {
    path: "/app_settings",
    element: AppSettings,
    userType: "ADMIN",
    type: "settings",
    plan_type: "Premium",
  },
  {
    path: "/user_scope_roles",
    element: UserScopesMaster,
    userType: "ADMIN",
    type: "settings",
    plan_type: "Premium",
  },
  {
    path: "/user_default_setting",
    element: UserDefaultSetting,
    userType: "MANAGER ADMIN",
    type: "settings",
    plan_type: "Premium",
    required_scopes: "read:accounts",
  },
  {
    path: "/create_db",
    element: CreateCompanyDb,
    userType: "ADMIN",
    type: "settings",
    plan_type: "Premium",
  },
  {
    path: "/settings",
    element: Settings,
    userType: "allowed",
    type: "menu",
    plan_type: "Premium",
  },

  // Utility Routes
  {
    path: "/image_library",
    element: ImageLibrary,
    userType: "ADMIN",
    type: "utility",
    plan_type: "Premium,",
  },
  {
    path: "/product_img_library",
    element: ImageMaster,
    userType: "ADMIN",
    type: "utility",
    plan_type: "Premium",
  },
  {
    path: "/fieldway_location",
    element: LiveMap,
    userType: "ADMIN",
    type: "utility",
    plan_type: "Premium",
  },
  {
    path: "/masters",
    element: Masters,
    userType: "allowed",
    type: "menu",
    plan_type: "Premium,Standard,Godown",
  },
  {
    path: "/updation",
    element: Updation,
    userType: "allowed",
    type: "menu",
    plan_type: "Premium,Standard,Godown",
  },
  {
    path: "/item_status",
    element: ItemStatus,
    userType: "allowed",
    type: "utility",
    required_scopes: "read:master,write:master",
    plan_type: "Premium,Godown",
  },
  {
    path: "/recieved_orders",
    element: ReceivedOrders,
    userType: "allowed",
    type: "utility",
    plan_type: "Premium,Standard",
    required_scopes: "read:master,write:master",
  },
];

const AppRoutes = ({ userType }) => {
  const authRoutes = [
    {
      path: "login",
      element: <LoginV3 />,
    },
    {
      path: "landing",
      element: <LandingPage />,
    },
    {
      path: "newLogin",
      element: <NewLoginModal />,
    },
    {
      path: "mobile_signup",
      element: <MobileSignUp />,
    },
    {
      path: "barCode",
      element: <QRCodeScanner />,
    },

    {
      path: "reset_password_email",
      element: <ResetEmail />,
    },
  ];
  const token = useSelector(selectToken);
  const otherRouter = [
    "/changeUserPassword",
    "/activateUser",
    "/emailVerified",
    "/invoice",
    "/customerEmail",
    "/auth/mobile_signup",
    "/auth/barCode",
    "/auth/newLogin",
    "/auth/login",
    "/terms_conditions",
    "/contact",
    "/landing",
  ];

  const expires = localStorage.getItem("expiresAt");
  const date = new Date().getTime();
  const navigate = useNavigate();
  const location = useLocation();

  const UserTime = () => {
    if (expires) {
      if (expires < date) {
        navigate("/landing");
      }
    } else {
      navigate("/landing");
    }
  };

  useEffect(() => {
    const isOtherRoute = otherRouter.filter((r) => r === location.pathname);
    if (!isOtherRoute[0]) {
      UserTime();
    }
  }, []);

  const user_module = decodeToken(token)?.user_modules || "default";
  const user_modules = user_module.split(",");
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-screen bg-gray-100">
          <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-orange"></div>
            <p className="mt-4 text-gray-600 text-lg">Loading...</p>
          </div>
        </div>
      }
    >
      <Routes>
        <Route path="/auth" element={<Auth />}>
          {authRoutes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Route>
        <Route path="*" element={<NotFound />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        >
          {privateRoutes.map((route, index) => {
            return (
              <Route
                key={index}
                path={route.path}
                element={
                  user_modules.find(
                    (e) =>
                      e === route.path.replace(/_/g, "-").replace(/\//g, "")
                  ) ||
                  (user_modules.find((e) => e === "default") &&
                    (route.userType.includes("allowed") ||
                      route.userType.includes(userType))) ? (
                    <ProtectedRoute>
                      {" "}
                      <route.element />
                    </ProtectedRoute>
                  ) : (
                    <NotFound />
                  )
                }
              />
            );
          })}
        </Route>
        <Route path="/changeUserPassword" element={<ForgotPassword />} />
        <Route path="/activateUser" element={<ActivationAccount />} />
        <Route path="/emailVerified" element={<VerifyEmail />} />
        <Route path="/invoice" element={<InvoiceBill />} />
        <Route path="/customerEmail" element={<CustomerEmailVerified />} />
        <Route path="/terms_conditions" element={<TermAndCondition />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/landing" element={<LandingPage />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
